<template>

    <main class="gmp-page gmp-page--no-newsletter">

<!--        <DS_heroLanding />-->
        <DS_scondHero />
        <DS_highLights :clientWidth="clientWidth"/>
        <DS_twoTout />


        <div>office</div>


    </main>

</template>


<script>
    // import DS_heroLanding from "../../components/content/enterprise/overView/DS_heroLanding";
    import DS_scondHero from "../../components/content/enterprise/overView/DS_scondHero";
    import DS_highLights from "../../components/content/enterprise/overView/DS_highLights";
    import DS_twoTout from "../../components/content/enterprise/overView/DS_twoTout";


    export default {
        name: 'DirectStore',
        components: {
            // DS_heroLanding,
            DS_scondHero,
            DS_highLights,
            DS_twoTout,

        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
